import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { getPriceRaiseHistoryContractId } from '../../model/selectors/getContractId';
import { priceRaiseHistoryModalActions } from '../../model/slice/priceRaiseHistoryModalSlice';

interface HookApi {
  isOpened: boolean;
  contractId: Nullable<string>;
  openPriceRaiseHistoryModal: (contractId: string) => void;
  closePriceRaiseHistoryModal: () => void;
}

export const usePriceRaiseHistoryModal = (): HookApi => {
  const dispatch = useAppDispatch();

  const contractId = useAppSelector(getPriceRaiseHistoryContractId);

  const openPriceRaiseHistoryModal = useCallback(
    (selectedContractId: string) => {
      dispatch(priceRaiseHistoryModalActions.openModal(selectedContractId));
    },
    [dispatch],
  );

  const closePriceRaiseHistoryModal = useCallback(() => {
    dispatch(priceRaiseHistoryModalActions.closeModal());
  }, [dispatch]);

  return {
    isOpened: Boolean(contractId),
    contractId,
    openPriceRaiseHistoryModal,
    closePriceRaiseHistoryModal,
  };
};
